<template>
  <div class="pagination">
    <a class="prev" href="javascript:;" v-if="this.next.length != 0 && this.prev.length === 0">上一项：无</a>
    <router-link class="prev" :to="'/' + url+ '/' + prev.id + prevType" v-if="this.prev.length != 0">上一项：{{ prev.name }}</router-link>
    <a class="next" href="javascript:;" v-if="this.prev.length != 0 && this.next.length === 0">下一项：无</a>
    <router-link class="next" :to="'/' + url+ '/' + next.id + nextType" v-if="this.next.length != 0">下一项：{{ next.name }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['id', 'url'],
  data () {
    return {
      paginationData: this.util.getLS('paginationData'),
      prev: {},
      next: {},
      prevType: '',
      nextType: ''
    }
  },
  methods: {
    getPage () {
      if (this.paginationData) {
        let data = new FormData()
        data.append('currentId', this.id)
        data.append('items', JSON.stringify(this.paginationData))

        this.util.post(this.api.pager, data, (success) => {
          this.prev = success.prev
          this.next = success.next
          if (success.prev.type) {
            this.prevType = '/' + this.prev.type
          }
          if (success.next.type) {
            this.nextType = '/' + this.next.type
          }
        })
      }
    }
  },
  watch: {
    '$route' (to) {
      this.id = parseInt(to.params.id)
      this.getPage()
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/functions";
  .pagination {
    padding: 0 pxToRem(30px);
    margin-top: pxToRem(20px);

    a {
      display: block;
      margin: 0 auto;
      color: #007aff;

      &.prev {
        margin-top: pxToRem(30px);
        margin-bottom: pxToRem(30px);
      }

      &.next {
        margin-bottom: pxToRem(30px);
      }

      span {
        color: #9F9FA0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue